import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=dedfc620&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=dedfc620&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedfc620",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dedfc620')) {
      api.createRecord('dedfc620', component.options)
    } else {
      api.reload('dedfc620', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=dedfc620&scoped=true&", function () {
      api.rerender('dedfc620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/Home.vue"
export default component.exports